import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import PracticeColours from "api/types/models/practice_colours";

export interface TempColours {
  darkColor: string | null;
  onDarkColor: string | null;
  primaryColor: string | null;
  onPrimaryColor: string | null;
  lightColor: string | null;
  onLightColor: string | null;
  lightestColor: string | null;
  onLightestColor: string | null;
}

const initialState: TempColours = {
  darkColor: null,
  onDarkColor: null,
  primaryColor: null,
  onPrimaryColor: null,
  lightColor: null,
  onLightColor: null,
  lightestColor: null,
  onLightestColor: null,
};

export const themeColours = createSlice({
  name: "practiceColours",
  initialState,
  reducers: {
    setTempColours: (
      state,
      colours: PayloadAction<Partial<PracticeColours>>,
    ) => {
      if (colours.payload?.dark_color) {
        state.darkColor = colours.payload.dark_color;
      }

      if (colours.payload?.on_dark_color) {
        state.onDarkColor = colours.payload.on_dark_color;
      }

      if (colours.payload?.primary_color) {
        state.primaryColor = colours.payload.primary_color;
      }

      if (colours.payload?.on_primary_color) {
        state.onPrimaryColor = colours.payload.on_primary_color;
      }

      if (colours.payload?.light_color) {
        state.lightColor = colours.payload.light_color;
      }

      if (colours.payload?.on_light_color) {
        state.onLightColor = colours.payload.on_light_color;
      }

      if (colours.payload?.lightest_color) {
        state.lightestColor = colours.payload.lightest_color;
      }

      if (colours.payload?.on_lightest_color) {
        state.onLightestColor = colours.payload.on_lightest_color;
      }
    },

    clearTempColours: (state) => {
      state.darkColor = null;
      state.onDarkColor = null;
      state.primaryColor = null;
      state.onPrimaryColor = null;
      state.lightColor = null;
      state.onLightColor = null;
      state.lightestColor = null;
      state.onLightestColor = null;
    },
  },
});

export const { setTempColours, clearTempColours } = themeColours.actions;

export default themeColours.reducer;
